export default "__VITE_ASSET__BkrzdoI1__"